import { JSX } from 'react';

import { Icon, Text, Tooltip, cn, getAccessibleFocusStyles } from '@videoblocks/design-system';

export interface TextInputAvailableCreditsProps {
    credits: number;
}

export const TextInputAvailableCredits = ({ credits }: TextInputAvailableCreditsProps): JSX.Element => {
    return (
        <div className="flex items-center gap-x-1">
            <Tooltip
                title="Credit usage depends on text length and clip duration."
                variant="light"
                trigger={
                    <button
                        type="button"
                        aria-label="Credit usage information"
                        className={cn('order-2 md:order-1', getAccessibleFocusStyles())}
                    >
                        <Icon name="informationCircleInverted" className="w-5 h-5" />
                    </button>
                }
                className="max-w-[270px] w-full text-center"
            />
            <Text fontSize="sm" fontWeight="regular" className="text-neutral-dark-800 text-right order-1 md:order-2">
                {credits?.toLocaleString()} {credits === 1 ? 'credit' : 'credits'} available
            </Text>
        </div>
    );
};
